import ClickToCallContent from './clickToCallContent';

const clickToCall = {
  name: 'Click to call',
  Content: ClickToCallContent,
  setInitialContent: (content = {}) => {
    return {
      instanceId: content.instanceId || '',
      contactFlowId: content.contactFlowId || '',
      sourcePhoneNumber: content.sourcePhoneNumber || '',
      destinationPhoneNumber: content.destinationPhoneNumber || '',
      region: content.region || '',
      attributes: content.attributes || []
    };
  },
  valid: content => {
    return Boolean(
      content.instanceId &&
        content.contactFlowId &&
        content.sourcePhoneNumber &&
        content.destinationPhoneNumber
    );
  }
};

export default clickToCall;
